import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { config } from '@/config'

import PublicLayout from '@/layouts/PublicLayout'
import AppLayout from '@/layouts/AppLayout'

import HomePublic from './views/HomePublic.vue'
import User from './views/User.vue'
import Login from './views/Login.vue'
import Register from './views/Register.vue'
import Logout from './views/Logout.vue'

Vue.use(Router)

const router = new Router({
  routes: [

    {
      path: '/',
      name: '',
      component: PublicLayout,

      children: [
        {
          path: '',
          name: 'public-home',
          component: HomePublic
        },
        {
          path: 'login',
          name: 'login',
          component: Login
        },
        {
          path: 'register',
          name: 'register',
          component: Register
        },
      ]

    },

    {
      path: '/app',
      name: 'App',
      component: AppLayout,
      children: [

        {
          path: '/',
          name: 'app-home',
          component: User
        },

        {
          path: 'user/:userAddress',
          name: 'user',
          component: User
        },

        {
          path: 'logout',
          name: 'logout',
          component: Logout
        }
      ]
    }
  ]
})


router.beforeEach( async (to, from, next) => {
  // console.log(store.state.foo)
  if (to.path.includes('/app/')) {
    let loggedIn = false
    const savedAddress = localStorage.getItem(config.localStorageKey.login)
    if (savedAddress && window.Box.isLoggedIn(savedAddress)) {
      // console.log('before: ' + savedAddress)
      if (!store.state.myAddress) {
        store.state.myAddress = savedAddress
      }
      if (!store.state.box) {
        store.state.box = await window.Box.openBox(savedAddress, window.ethereum, {})
      }
      if (!store.state.appSpace || !store.state.myDid) {
        const box = await window.Box.openBox(savedAddress, window.ethereum, {})
        const appSpace = await box.openSpace(config.spaceName.app)
        // await new Promise((resolve, reject) => box.onSyncDone(resolve))
        store.state.appSpace = appSpace
        store.state.myDid = appSpace.DID
      }
      loggedIn = true
    }
    if (!loggedIn) {
      console.log('not logged in, redirecting to login')
      router.push({ name: 'login', query: { redirect: to.path }})
    }
  }
  next()
})

export default router
